<template>
  <el-container class="layout-container">
    <!-- 侧边栏 -->
    <el-aside width="220px" class="layout-aside">
      <div class="logo">
        <span class="logo-text">{{ isTeacher && !isAdmin ? '刷题系统 · 教师端' : '刷题系统管理后台' }}</span>
      </div>
      <el-menu
        :default-active="$route.path"
        router
        background-color="#001529"
        text-color="#ffffffa6"
        active-text-color="#fff"
        class="side-menu"
      >
        <el-menu-item v-if="isAdmin" index="/question/list">
          <i class="el-icon-collection"></i>
          <span>题库管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/paper/list">
          <i class="el-icon-document-copy"></i>
          <span>试卷管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/handout/list">
          <i class="el-icon-notebook-2"></i>
          <span>讲义管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/member/list">
          <i class="el-icon-user"></i>
          <span>会员管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/order/list">
          <i class="el-icon-tickets"></i>
          <span>订单管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/wrong/list">
          <i class="el-icon-warning-outline"></i>
          <span>错题管理</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/feedback/list">
          <i class="el-icon-chat-line-square"></i>
          <span>问题反馈</span>
        </el-menu-item>
        <el-menu-item v-if="isTeacher || isAdmin" index="/teacher/classes">
          <i class="el-icon-s-custom"></i>
          <span>教师工作台</span>
        </el-menu-item>
        <el-menu-item v-if="isTeacher && !isAdmin" index="/teacher/papers">
          <i class="el-icon-document-copy"></i>
          <span>试卷管理</span>
        </el-menu-item>
        <el-menu-item v-if="isTeacher && !isAdmin" index="/teacher/handouts">
          <i class="el-icon-notebook-2"></i>
          <span>讲义管理</span>
        </el-menu-item>
        <el-menu-item v-if="isTeacher && !isAdmin" index="/teacher/questions">
          <i class="el-icon-collection"></i>
          <span>题库管理</span>
        </el-menu-item>
        <el-menu-item v-if="isTeacher && !isAdmin" index="/teacher/wrong/list">
          <i class="el-icon-warning-outline"></i>
          <span>错题管理</span>
        </el-menu-item>
        <el-menu-item v-if="isTeacher && !isAdmin" index="/teacher/feedback">
          <i class="el-icon-chat-line-square"></i>
          <span>问题反馈</span>
        </el-menu-item>
        <el-menu-item index="/system/admin" v-if="isAdmin">
          <i class="el-icon-setting"></i>
          <span>管理员管理</span>
        </el-menu-item>
        <el-menu-item index="/system/basedata" v-if="isAdmin">
          <i class="el-icon-data-line"></i>
          <span>基础数据管理</span>
        </el-menu-item>
        <el-menu-item index="/system/export-billing" v-if="isAdmin">
          <i class="el-icon-money"></i>
          <span>导出计费设置</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <!-- 主区域 -->
    <el-container>
      <!-- 顶部导航 -->
      <el-header v-if="!$route.meta.fullPage" class="layout-header">
        <span class="page-title">{{ $route.meta.title || '管理后台' }}</span>
        <div class="header-right">
          <span class="admin-name">{{ adminInfo.username }}</span>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 内容区 -->
      <el-main :class="['layout-main', { 'layout-main--full': $route.meta.fullPage }]">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Layout',
  computed: {
    adminInfo() {
      try {
        return JSON.parse(localStorage.getItem('admin_info') || '{}')
      } catch {
        return {}
      }
    },
    isAdmin() {
      return this.adminInfo.role === 'ADMIN'
    },
    isTeacher() {
      return this.adminInfo.role === 'TEACHER'
    }
  },
  methods: {
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$confirm('确认退出登录？', '提示', { type: 'warning' }).then(() => {
          localStorage.removeItem('admin_token')
          localStorage.removeItem('admin_info')
          this.$router.push('/login')
        }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}
.layout-aside {
  background: #001529;
  overflow: hidden;
}
.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
.logo-text {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}
.side-menu {
  border: none;
  height: calc(100vh - 60px);
}
.layout-header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
}
.page-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.admin-name {
  color: #333;
  font-size: 14px;
}
.el-dropdown-link {
  cursor: pointer;
}
.layout-main {
  background: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
}
.layout-main--full {
  padding: 0;
  overflow: hidden;
  height: 100vh;
}
</style>
